import { SVGProps } from 'react'

const SvgExportIconBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="34"
    height="36"
    viewBox="0 0 30 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.38237 13.3333L5.11766 9.16668L6.31178 7.95834L8.52943 10.125V3.33334H10.2353V10.125L12.453 7.95834L13.6471 9.16668L9.38237 13.3333ZM4.26472 16.6667C3.7956 16.6667 3.39401 16.5035 3.05994 16.1771C2.72587 15.8507 2.55884 15.4583 2.55884 15V12.5H4.26472V15H14.5V12.5H16.2059V15C16.2059 15.4583 16.0389 15.8507 15.7048 16.1771C15.3707 16.5035 14.9691 16.6667 14.5 16.6667H4.26472Z"
      fill="#757575"
    />
    <path
      d="M24.6698 8.47968L22.5868 10.4453L20.5037 8.47968C20.401 8.39669 20.2689 8.35332 20.1338 8.35824C19.9987 8.36317 19.8705 8.41602 19.7749 8.50625C19.6793 8.59647 19.6233 8.71742 19.6181 8.84492C19.6129 8.97243 19.6588 9.09709 19.7468 9.19401L22.211 11.5194C22.3116 11.6137 22.4476 11.6667 22.5895 11.6667C22.7313 11.6667 22.8674 11.6137 22.9679 11.5194L25.4321 9.19401C25.5321 9.09909 25.5883 8.97068 25.5883 8.83684C25.5883 8.70301 25.5321 8.5746 25.4321 8.47968C25.3302 8.38586 25.1934 8.33334 25.051 8.33334C24.9086 8.33334 24.7718 8.38586 24.6698 8.47968Z"
      fill="#5E5E5E"
    />
  </svg>
)

export default SvgExportIconBlue
